import { DeltaBadge } from "../primitives";
import { FunnelStage } from "./types";
import styles from "./style.module.scss";

interface FunnelBarsProps {
  stages: FunnelStage[];
  /** Formats the raw value; defaults to a plain locale string. */
  format?: (value: number) => string;
}

/** Default funnel view: one labelled progress bar per stage. */
function FunnelBars({ stages, format }: FunnelBarsProps) {
  const toText = format ?? ((value: number) => value.toLocaleString("en-US"));

  return (
    <div className={styles.bars}>
      {stages.map((stage, index) => (
        <div key={stage.key} className={styles.barRow}>
          <div className={styles.barHead}>
            <div className={styles.barLabel}>
              <span className={styles.stageDot} style={{ background: stage.color }}>
                {stage.stage}
              </span>
              <span className={styles.stageName}>{stage.label}</span>
            </div>
            <div className={styles.barFigures}>
              <span className={styles.barValue}>{toText(stage.value)}</span>
              <DeltaBadge delta={stage.delta} size="sm" hideAgainst />
            </div>
          </div>
          <div className={styles.barTrack}>
            <div className={styles.track}>
              <div
                className={styles.fill}
                style={{
                  width: `${stage.share}%`,
                  background: `linear-gradient(90deg, ${stage.color}, ${
                    stages[Math.min(index + 1, stages.length - 1)].color
                  })`,
                }}
              />
            </div>
            <span className={styles.barShare}>
              {`${Math.round(stage.share)}% of seats`}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
}

export default FunnelBars;
